"use client";

import React, { useState } from "react";
import { motion } from "framer-motion";
import Image from "next/image";
import Button from "@/components/ui/Button";
import ScheduleCallModal from "@/components/common/ScheduleCallModal";
import { ParticleSphere } from "./ParticleSphere";

export default function HeroSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="bg-brand-black relative flex min-h-[65vh] w-full flex-col items-center justify-center overflow-hidden md:min-h-screen">
      {/* Background Radial Gradient */}
      <div
        className="pointer-events-none absolute inset-0 h-full w-full opacity-80"
        style={{
          background:
            "radial-gradient(circle at 50% 35%, #EE4137 0%, #A10900 45%, #181818 85%)",
        }}
      />

      <div
        className="pointer-events-none absolute inset-0 hidden h-full w-full opacity-40 md:block"
        style={{
          background:
            "radial-gradient(ellipse 80% 80% at 75% 25%, #EE4137 0%, transparent 100%)",
        }}
      />

      <div className="pointer-events-none absolute inset-0 z-0 flex items-center justify-center">
        <div className="relative h-[100vh] w-[100vw]">
          <ParticleSphere />
        </div>
      </div>

      {/* Dark Overlay for Readability */}
      <div
        className="pointer-events-none absolute inset-0 z-[5] h-full w-full"
        style={{
          background:
            "radial-gradient(circle at center, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0.7) 100%)",
        }}
      />

      <div className="relative z-10 -mt-10 flex w-full max-w-4xl flex-col items-center px-6 text-center md:mt-0">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="mb-6 md:mb-8"
        >
          <Image
            src="/halcyon-full-logo.webp"
            alt="Halcyon Logo"
            width={300}
            height={100}
            className="h-auto w-[180px] md:w-[300px]"
            priority
          />
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="font-raleway mb-2 text-lg font-semibold tracking-wide text-white md:mb-2.5 md:text-[2rem] md:font-normal"
        >
          Shop Revenue-Boosting
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          className="font-goldman mb-4 w-full text-[26px] leading-[1.1] font-bold tracking-tight text-white uppercase drop-shadow-[0_0_5px_rgba(238,65,55,0.4)] sm:text-[34px] md:mb-2.5 md:text-5xl lg:text-6xl"
        >
          Skill Games & COAMS
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="font-raleway mb-8 max-w-2xl text-base text-white md:mb-10 md:text-xl"
        >
          Increase Your Profit With NO cost to you!
          <br />
          Get a FREE Consultation Today.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          <Button
            variant="white"
            className="z-10"
            onClick={() => setIsModalOpen(true)}
          >
            Schedule a Call
          </Button>
        </motion.div>
      </div>

      <div
        className="pointer-events-none absolute bottom-0 left-0 z-[6] h-40 w-full"
        style={{
          background:
            "linear-gradient(to bottom, transparent 0%, #181818 100%)",
        }}
      />

      <ScheduleCallModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </section>
  );
}
